/*
 |--------------------------------------------------------------------------
 | Inpage navigatie module
 |--------------------------------------------------------------------------
 */

 /* ========================================================================== *\
 IMPORTS
 \* ========================================================================== */

 import $ from 'jquery';

 /* == END IMPORTS =========================================================== */

 /* ========================================================================== *\
  CONSTANTS
 \* ========================================================================== */

 const
     /**
      * The module name
      * @type {String}
      */
     moduleName = 'inpage-navigatie',
     /**
      * Lookup table for selectors
      * @type {Object}
      */
     selectors = {
         inpageNavigatie: `.js-${ moduleName }`,
         pillList: `.pill-list`
     },
     elements = {
         inpageNavigaties: $(selectors.inpageNavigatie)
     };

 /* == END CONSTANTS ========================================================= */

 /* ========================================================================== *\
  SETUP INPAGE NAVIGATIE
 \* ========================================================================== */

const determineOverlayState = (element) => {
    window.requestAnimationFrame(function() {
        if (element.scrollLeft > 0) {
            $(element).removeClass('pill-list--gradient');
        } else {
            $(element).addClass('pill-list--gradient');
        }
    });
}

 /* == END SETUP HERO ===================================================== */

 /* ========================================================================== *\
  INITIALIZATION
 \* ========================================================================== */

 /**
  * Initialize in-page module
  */
function init() {

    elements.inpageNavigaties.each(function() {
        const element = this;
        const pillList = $(element).find(selectors.pillList)[0];

        // add/remove overlay on start-up
        determineOverlayState(pillList);

        // add/remove overlay on scroll event
        pillList.addEventListener('scroll', function() {
            determineOverlayState(pillList);
        });
    });

}

if (elements.inpageNavigaties.length){
    init();
}

 /* == END INITIALIZATION ==================================================== */
